module.exports = __webpack_public_path__ + "img/profile_av.9037f90c.jpg";